export enum GraduateParticipantStatus {
  Pending = 'Pending',
  Approved = 'Approved',
  Suspended = 'Suspended',
  Rejected = 'Rejected',
}

export interface GraduateParticipant {
  id: string;
  email: string;
  fullName: string;
  dateOfBirth?: string;
  status: GraduateParticipantStatus;
  department?: string;
  cohort?: string;
  intakeYear?: number;
  createdAtUtc: string;
  approvedAtUtc?: string;
  approvedByUserId?: string;
}
